// api.js - Merkezi API yapılandırması ile güncellendi
import { getApiUrl, API_ENDPOINTS, apiRequest } from './config/apiConfig';

// Proxy üzerinden TMDB verilerini çekmek için
export const fetchDetailsProxy = async (mediaType, id) => {
  const res = await fetch(`${getApiUrl(API_ENDPOINTS.FETCH_DETAILS)}?id=${id}&type=${mediaType}`);
  if (!res.ok) throw new Error('Detaylar çekilemedi');
  return res.json();
};

export const fetchSeasonDetailsProxy = async (tvId, seasonNumber) => {
  const res = await fetch(`${getApiUrl(API_ENDPOINTS.FETCH_SEASON)}?id=${tvId}&season=${seasonNumber}`);
  if (!res.ok) throw new Error('Sezon detayları çekilemedi');
  return res.json();
};

export const fetchKeywordsProxy = async (mediaType, id) => {
  const res = await fetch(`${getApiUrl(API_ENDPOINTS.FETCH_KEYWORDS)}?id=${id}&type=${mediaType}`);
  if (!res.ok) throw new Error('Anahtar kelimeler çekilemedi');
  return res.json();
};

// Görsel proxy fonksiyonu
export const getImageUrl = (path, size = 'w500') => {
  if (!path) return '/placeholder-image.jpg';
  return `${getApiUrl(API_ENDPOINTS.PROXY_IMAGE)}?path=${encodeURIComponent(path)}&size=${size}`;
};

export const searchMulti = async (query) => {
  const res = await fetch(`${getApiUrl(API_ENDPOINTS.TMDB_SEARCH)}?query=${encodeURIComponent(query)}`);
  if (!res.ok) throw new Error('Arama yapılamadı');
  return res.json();
};
